import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Map, fromJS, List} from 'immutable';
import _ from 'lodash';

import template from './AssignPopup.rt';
import {showAssignPopup} from "./Actions";
// import {getFilterGroups, saveFiltersForEntities} from "../FiltersActions";
import {saveFiltersForEntities} from "../FiltersActions";
import * as Misc from '../../../misc';
import {getApiConfig} from "../../../utilities";
import {loadingDialog_show} from "../../../actions";
import {getCurrentGroupCheckedFeatures} from "./Reducer";
import {getAllFilterGroups} from "../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";

const mapStateToProps = state => {
  const {filtersAssignToFeatures} = state;
  return {
    features: getCurrentGroupCheckedFeatures(filtersAssignToFeatures),
    allFilterGroups: state.featuresFiltersState.allFilterGroups
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    close: () => dispatch(showAssignPopup(false)),
    saveFiltersForEntities: (entityType, entitiesIDs, filterGroupValues) =>
      dispatch(saveFiltersForEntities(entityType, entitiesIDs, filterGroupValues))
  }
}

class AssignPopup extends Component {
  selectedFilterValues = {}

  constructor(props) {
    super(props);

    this.state = {
      selectedGroupID: 0,
      filterGroupValues: Map(),
      filterValuesFromCurrentGroup: List(),
      excludedFeatures: {}
    };
  }

  componentDidMount() {
    if (!this.props.allFilterGroups.length) {
      this.props.dispatch(loadingDialog_show(true, 'Loading...', 'Loading filter groups...'))
      getAllFilterGroups()
        .then((response) => {
          this.props.dispatch(loadingDialog_show(false));
          this.selectGroup(null, response[0]);
        })
    } else {
      this.selectGroup(null, this.props.allFilterGroups[0]);
    }
  }

  excludeFeature = (e, feature) => {
    e && Misc.ignoreDefault(e);

    const {excludedFeatures} = this.state;
    if (excludedFeatures[feature.id])
      delete excludedFeatures[feature.id];
    else
      excludedFeatures[feature.id] = true;

    this.setState({excludedFeatures});
  }

  selectGroup = (e, group) => {
    e && Misc.ignoreDefault(e);

    const values = this.state.filterGroupValues.get(group.id);
    if (!values) {
      this.props.dispatch(loadingDialog_show(true, 'Loading', 'Load Filter values'));
      getApiConfig('Filters/FilterGroupValues/' + group.id)
        .get()
        .then(result => {
          this.props.dispatch(loadingDialog_show(false));
          let {filterGroupValues} = this.state;
          const filterValuesFromCurrentGroup = fromJS(result);
          filterGroupValues = filterGroupValues.set(group.id, filterValuesFromCurrentGroup);
          this.setState({
            filterGroupValues,
            filterValuesFromCurrentGroup: this.restoreCheckedFilters(filterValuesFromCurrentGroup),
            selectedGroupID: group.id
          });
        });
      return;
    }

    this.setState({
      selectedGroupID: group.id,
      filterValuesFromCurrentGroup: this.restoreCheckedFilters(values)
    });
  }

  /**
   *
   * @param filterGroupValues {List}
   */
  restoreCheckedFilters = (filterGroupValues) => {
    _.forEach(this.selectedFilterValues, (v, filterValueID) => {
      const idx = filterGroupValues.findIndex(_ => _.get('id') === +filterValueID);
      if (idx !== -1)
        filterGroupValues = filterGroupValues.setIn([idx, 'checked'], true);
    });

    return filterGroupValues;
  }

  handleFilterClick = (filter, type) => {
    if (filter.checked)
      this.selectedFilterValues[filter.id] = this.state.selectedGroupID;
    else
      delete this.selectedFilterValues[filter.id];
  }

  handleSave = () => {
    const entitiesIDs = _.filter(this.props.features, f => !this.state.excludedFeatures[f.id])
      .map(f => f.id);
    const filterGroupValues = {};
    _.forEach(this.selectedFilterValues,  (filterGroupID, filterValueID) => {
      if (!filterGroupValues[filterGroupID])
        filterGroupValues[filterGroupID] = [];
      filterGroupValues[filterGroupID].push(filterValueID);
    });

    this.props.saveFiltersForEntities('feature', entitiesIDs, filterGroupValues);
    this.props.close();
  }

  render() {
    return template.apply(this);
  }
}

AssignPopup.propTypes = {
  close: PropTypes.func.isRequired,
  saveFiltersForEntities: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignPopup);

